/* cx: desktop-only — size the flexible spacer so the buy group
   (shipping banner → SKU) ends at the bottom of the first viewport,
   regardless of how tall the Combine-it-with block below it is. */
(function () {
  'use strict';

  var PAD = 24; // breathing room under the SKU

  function anchor() {
    var spacer = document.querySelector('.cx-flex-spacer');
    if (!spacer) return;
    if (window.innerWidth < 750) {
      spacer.style.height = '';
      return;
    }
    var group = document.querySelector('.product__sku') ||
      document.querySelector('.cx-kave-rows');
    if (!group) return;
    spacer.style.height = '0px';
    var bottomDoc = group.getBoundingClientRect().bottom + window.scrollY;
    var h = Math.round(window.innerHeight - PAD - bottomDoc);
    spacer.style.height = Math.max(24, h) + 'px';
  }

  var t;
  function debounced() {
    clearTimeout(t);
    t = setTimeout(anchor, 150);
  }

  window.addEventListener('resize', debounced);
  window.addEventListener('load', anchor);
  /* variant switches re-render parts of the column and change its height */
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, .cx-variant-sheet')) debounced();
  });
  if (document.readyState !== 'loading') { anchor(); } else { document.addEventListener('DOMContentLoaded', anchor); }
})();
